// aiinsikt-report-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1a.report.pdfBackendUnavailable': 'The PDF backend is not available.',
  'r1a.report.pdfDownloadFailed': 'Could not download the PDF.',
  'r1a.report.openingPrint': 'Opening print …',
  'r1a.report.subtitleMonthly': 'Monthly report · result',
  'r1a.report.subtitleYearly': 'Annual report · result',
  'r1a.report.comparedWith': ' · compared with {period}',
  'r1a.report.chartTitle': 'Income and costs per month · {year}',
  'r1a.report.footnote': 'The reports are generated from posted transactions. Earlier years are available as long as the accounts have been kept. The comparison shows the same period the year before.',
});
